import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonGroup, IconButton } from '@dixa/lib-shared-habla';
import { memo } from 'react';
import { analytics } from 'app/utils/segment';
import { useAnalyticsState } from 'app/views/layout/views/analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';
import { visualizationIcons } from '../../utils/appearance';
const visualizations = ['bar', 'line'];
export const ChartInstrumentVisualization = memo(function ChartInstrumentVisualization({ panel, visualization, onChangeVisualization, }) {
    const { dashboard } = useAnalyticsState();
    return (_jsx(ButtonGroup, Object.assign({ variant: "secondary" }, { children: visualizations.map((item) => (_jsx(IconButton, { icon: visualizationIcons[item], onClick: () => {
                onChangeVisualization(item);
                analytics.analyticsChartVisualizationChanged({
                    visualization: item,
                    panel: panel.title,
                    dashboard: dashboard.title,
                });
            }, active: visualization === item }, item))) })));
});
